import { render, staticRenderFns } from "./VersoesPesquisa.vue?vue&type=template&id=55838b50&scoped=true&"
import script from "./VersoesPesquisa.vue?vue&type=script&lang=js&"
export * from "./VersoesPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./VersoesPesquisa.vue?vue&type=style&index=0&id=55838b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55838b50",
  null
  
)

export default component.exports